module.exports = __webpack_public_path__ + "img/price-3290.31bcd62d.png";